import { render } from "./CertAlcoholDashboard.vue?vue&type=template&id=7cea61f0&scoped=true"
import script from "./CertAlcoholDashboard.vue?vue&type=script&lang=js"
export * from "./CertAlcoholDashboard.vue?vue&type=script&lang=js"

import "./CertAlcoholDashboard.vue?vue&type=style&index=0&id=7cea61f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cea61f0"]])

export default __exports__